import { z } from 'zod';

const MyProfileFormSchema = z.object({
  photo_url: z.string().nullish().optional(),
  first_name: z.string({ message: "First Name can't be empty" }).min(1, {
    message: "First Name can't be empty",
  }),
  last_name: z.string({ message: "Last Name can't be empty" }).min(1, {
    message: "Last Name can't be empty",
  }),
  birth_date: z.string().nullish().optional(),
  city: z.string().nullish().optional(),
  state: z
    .string()
    .length(2, { message: 'State must be exactly 2 characters (e.g. NY, TX)' })
    .transform((val) => val.toUpperCase())
    .refine((val) => /^[A-Z]{2}$/.test(val), {
      message: 'State must be 2 letters only (e.g. NY, TX)',
    })
    .nullish()
    .optional(),
  zip_code: z.string().nullish().optional(),
  address: z.string({ message: "Address can't be empty" }).min(1, {
    message: "Address can't be empty",
  }),
  phone: z.string({ message: "Phone can't be empty" }).min(1, {
    message: "Phone can't be empty",
  }),
  email: z
    .string({ message: "Email can't be empty" })
    .email({ message: 'Invalid Email Address' }),
  linkedin: z.string().nullish().optional(),
  preferred_markets: z
    .array(z.string({ message: 'Please select at least 1 market' }), {
      message: 'Please select at least 1 market',
    })
    .min(1, {
      message: 'Please select at least 1 market',
    })
    .max(5, {
      message: 'You can select up to 5 markets',
    }),
});

export { MyProfileFormSchema };
